import { CocoCallMeBack } from "components/kelas-live/assets/coco-call-me-back";
import React, { useEffect } from "react";
import { Spacer } from "styles/common/spacer";
import { KakakSiagaNumber } from "../kelas-live-cmb.data";
import {
  CMBHeading,
  CMBModalWrapper,
  CMBSubHeading,
  StyledButton
} from "./kelas-live-cmb-info-modal.styles";
import { KelasLiveCMBModal } from "../kelas-live-cmb-modal/kelas-live-cmb-modal";
import trackEvent from "services/mixpanel/mixpanel";
import { kelasLiveEvents } from "services/mixpanel/kelas-live-events";

import { useBoolean } from "hooks/use-boolean/use-boolean";
import { trackClassmonEvent } from "services/api/classmon/classmonService";
import { useKelasLiveContext } from "stores/kelas-live/kelas-live-context";

const KelasLiveCMBInfoModal: React.FC<{
  onClose: () => void;
  onGoingClassExists: boolean;
}> = ({ onClose, onGoingClassExists }) => {
  const [isLoading] = useBoolean(false);

  const kelasLiveContext = useKelasLiveContext();

  useEffect(() => {
    trackEvent({
      eventName: kelasLiveEvents.contactKakakSiagaBottomSheetViewed,
      payload: {
        cause: "USER_CLICK",
        eventSource: "website",
        isClassOngoing: onGoingClassExists
      }
    });
  }, [onGoingClassExists]);

  const handleContactKakakSiagaButtonClick = () => {
    trackClassmonEvent(
      "support_requested",
      kelasLiveContext.user.userData.primary_user.id,
      null
    ).catch(() => {});
    trackEvent({
      eventName: kelasLiveEvents.callMeKakClicked,
      payload: {
        cause: "USER_CLICK",
        eventSource: "website",
        isClassOngoing: onGoingClassExists
      }
    });
    window.location.href = `https://wa.me/62${KakakSiagaNumber.slice(1)}`;
  };

  const handleClose = () => {
    onClose();
    trackEvent({
      eventName: kelasLiveEvents.contactKakakSiagaBottomSheetDroppedOff
    });
  };

  return (
    <KelasLiveCMBModal isOpen={true} onClose={handleClose}>
      <CMBModalWrapper>
        <CocoCallMeBack width="120" height="120" />
        <Spacer token={[0, 0, 12]} />
        <CMBHeading>
          Ada kendala? Kakak Siaga akan <br /> bantu kamu
        </CMBHeading>
        <Spacer token={[0, 0, 12]} />
        <CMBSubHeading>Kakak siaga siap sedia di jam kerja</CMBSubHeading>
        <Spacer token={[0, 0, 24]} />
        <StyledButton
          variant="primary"
          isFullWidth={true}
          onClick={handleContactKakakSiagaButtonClick}
          isLoading={isLoading}
          loadingText="Chat Kakak Siaga di WA"
        >
          Chat Kakak Siaga di WA
        </StyledButton>
        <Spacer token={[0, 0, 24]} />
      </CMBModalWrapper>
    </KelasLiveCMBModal>
  );
};

export { KelasLiveCMBInfoModal };
